module.exports = __webpack_public_path__ + "img/loading.7e339c70.svg";